import { render, staticRenderFns } from "./DAdminIpRestriction.vue?vue&type=template&id=c9410150&scoped=true&"
import script from "./DAdminIpRestriction.vue?vue&type=script&lang=js&"
export * from "./DAdminIpRestriction.vue?vue&type=script&lang=js&"
import style0 from "./DAdminIpRestriction.vue?vue&type=style&index=0&id=c9410150&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9410150",
  null
  
)

export default component.exports